/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import DefMembershipActions from "../../Redux/actions/defMembership-actions";
import MembershipInviteActions from "../../Redux/transition/membership-invite/membership-invite.reducer";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { TabMenu } from "primereact/tabmenu";
import { classNames } from "primereact/utils";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import ColleaguesInvited from "./ColleaguesInvited";
import ColleaguesList from "./ColleaguesList"
import "../../App.css";
import "../../Styles/pages/colleagues.scss";
import { createCustomHandleChange } from "../../Components/CleanInputs"
import { removeTrailingSpacesAndDashes } from "../../Components/CleanInputs"

//let mount = false;
const Colleagues = () => {

  const { t } = useTranslation("common");
  const [activeIndex, setActiveIndex] = useState(0);
  const [errors, setErrors] = useState({});

  //Redux State from Store
  const defMembership = useSelector((state) => state.defMembership.defMembership);
  const errorInvite = useSelector((state) => state.membershipInvites.errorCreating);
  const creatingInvite = useSelector((state) => state.membershipInvites.creating);

  //Redux Dispatch Actions
  const dispatch = useDispatch();
  const createMembershipInvite = (membershipInvite) => {
    dispatch(
      MembershipInviteActions.membershipInviteCreateRequest(membershipInvite)
    );
  };

  const fetchAllInvitedMembers = useCallback((businessId, options) => {
    dispatch(
      MembershipInviteActions.membershipInviteAllRequest(businessId, options)
    );
  }, [dispatch])

  const getDefMembership = useCallback(() => {
    dispatch(DefMembershipActions.defMembershipRequest());
  }, [dispatch])

  const [state, setState] = useState({ creating: false, success: null, sort: 'invitedOn,desc' });
  const [displayBasic, setDisplayBasic] = useState(false);
  const toast = useRef(null);
  const roleService = [
    { roleName: t('colleague.manager'), code: "MANAGER" },
    { roleName: t('colleague.viewer'), code: "VIEWER" },
    { roleName: t('colleague.admin'), code: "ADMIN" },
  ];

  useEffect(() => {
    if (!defMembership) {
      getDefMembership();
    }

    if (defMembership) {
      fetchAllInvitedMembers(defMembership.business.id, { sort: state.sort })
    }
  }, [])

  useEffect(() => {
    if (state.creating && !creatingInvite) {
      if (errorInvite) {
        showError();
        setState((state) => ({ ...state, creating: false }))
      } else {
        showSuccess();
        setState((state) => ({ ...state, creating: false }))
      }
    }
  }, [creatingInvite, state.creating, defMembership, errorInvite]);

  const formik = useFormik({
    initialValues: {
      id: null,
      firstName: "",
      lastName: "",
      email: "",
      inviteRole: null,
    },

    validate: (data) => {
      let errors = {};

      if (!data.firstName) {
        errors.firstName = t('colleague.firstName_error');
      }

      if (!data.lastName) {
        errors.lastName = t('colleague.lastName_error');
      }
      if (!data.inviteRole) {
        errors.inviteRole = t('user_profile.role_error');
      }

      if (!data.email) {
        errors.email = t('colleague.email_error');
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.email)
      ) {
        errors.email = t('colleague.email_invalid');
      }
      return errors;
    },

    onSubmit: (data) => {
      const inviteData = {
        id: data.id || null,
        firstName: removeTrailingSpacesAndDashes(data.firstName) || null,
        lastName: removeTrailingSpacesAndDashes(data.lastName) || null,
        email: data.email || null,
        inviteRole: data.inviteRole?.code,
        invitedBy: { id: defMembership.id },
        business: { id: defMembership.business.id },
        invitedOn: new Date(),
        status: "PENDING",
      };

      createMembershipInvite(inviteData);
      setState((state) => ({ ...state, creating: true }))
    },
  });

  const customHandleChange = createCustomHandleChange(formik, setErrors, t);

  // Toast Success
  const showSuccess = () => {
    toast.current.show({
      severity: "success",
      summary: t('colleague.success'),
      detail: t('colleague.success_detail'),
      life: 3000,
    });
  }

  // Toast Error
  const showError = () => {
    toast.current.show({
      severity: "error",
      summary: t('colleague.error'),
      detail: errorInvite.status === 500 ? errorInvite.title : t('colleague.invite_error'),
      life: 3000,
    });
  }

  const items = [
    { label: t('colleague.colleagues'), className: "tab  tab1" },
    { label: t('colleague.invited'), className: "tab  edge-tab-end" },
  ];
  /* FORMIK */

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const toggleDialogDisplay = () => {
    setDisplayBasic(!displayBasic);
  };
  /* FORMIK */

  return (
    <div className="colleagues-page">
      <div className="colleagues-page-header">
        <Button
          label={t('colleague.invite_colleague')}
          icon="pi pi-plus-circle"
          className="send_button colleagues-invite-btn"
          onClick={toggleDialogDisplay}
          severity="info"
        />
        <TabMenu
          model={items}
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
          className="colleague-tab"
        />
      </div>

        <div className="card inviteTable" style={{ padding: "0" }}>

          <Dialog
            header={t('colleague.invite')}
            visible={displayBasic}
            style={{ width: "370px" }}
            breakpoints={{ "960px": "75vw", "640px": "95vw" }}
            onHide={toggleDialogDisplay}
            className="tier_dialog colleague-invite-dialog"
            id="tier_dialog"
          >
            <div className="colleague-invite-dialog__body">

              <Toast
                className="p-toast p-toast-container p-toast-item p-toast-message p-toast-title "
                ref={toast} onRemove={(message) => {
                  if (message.severity === 'success') {
                    formik.resetForm()
                    fetchAllInvitedMembers(defMembership.business.id, { sort: state.sort })
                    toggleDialogDisplay()
                  }
                }}
              />
              <form onSubmit={formik.handleSubmit} className="p-fluid colleague-invite-form">
                <div>
                  <InputText
                    id="firstName"
                    name="firstName"
                    value={formik.values.firstName}
                    onChange={customHandleChange}
                    autoFocus
                    style={{ height: "3rem", marginBottom: "0.5rem" }}
                    placeholder={t("colleague.firstName")}
                    className={classNames({
                      "p-invalid": isFormFieldValid("firstName"),
                    })}
                    maxLength={50}
                  />
                  <label htmlFor="firstName"></label>
                  {getFormErrorMessage("firstName")}
                  {errors.firstName && <p className="character_errors_colleagues">{errors.firstName}</p>}
                </div>

                <div style={{ marginTop: "1.5rem" }}>
                  <InputText
                    id="lastName"
                    name="lastName"
                    value={formik.values.lastName}
                    onChange={customHandleChange}
                    style={{ height: "3rem", marginBottom: "0.5rem" }}
                    placeholder={t("colleague.lastName")}
                    className={classNames({
                      "p-invalid": isFormFieldValid("lastName"),
                    })}
                    maxLength={50}
                  />
                  {getFormErrorMessage("lastName")}

                  {errors.lastName && <p className="character_errors_colleagues">{errors.lastName}</p>}
                </div>

                <div style={{ marginTop: "1.5rem" }}>
                  <InputText
                    id="inviteEmail"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    style={{ height: "3rem", marginBottom: "0.5rem" }}
                    placeholder={t('colleague.email')}
                    className={classNames({
                      "p-invalid": isFormFieldValid("email"),
                    })}
                    maxLength={50}
                  />
                  {getFormErrorMessage("email")}
                </div>

                <div className="inviteRole" style={{ marginTop: "1.5rem", marginBottom: "1rem" }}>
                  <Dropdown
                    id="inviteRole"
                    name="inviteRole"
                    value={formik.values.inviteRole}
                    onChange={(e) =>
                      formik.setFieldValue("inviteRole", e.value)
                    }
                    style={{ height: "3rem", marginBottom: "0.5rem" }}
                    options={roleService}
                    optionLabel="roleName"
                    placeholder={t('colleague.select_role')}
                    className={classNames({
                      "p-invalid": isFormFieldValid("inviteRole"),
                    })}
                  />
                  {getFormErrorMessage("inviteRole")}
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button type="submit" style={{ width: "fit-content" }} className="p-mt-2 colleague_invite" label={t('colleague.invite_button')} loading={creatingInvite} />
                </div>

              </form>
            </div>
          </Dialog>


          {activeIndex === 0 && <ColleaguesList />}
          {activeIndex === 1 && <ColleaguesInvited />}
        </div>
    </div>
  );
};

export default (Colleagues);
